export function shouldEnableImageGenerationSocket(pathname: string | null) {
  return pathname !== "/download" && !pathname?.startsWith("/download/");
}
